import apiClient from "./api_client";

const calendarService = {
  // Get all calendar events with optional filters
  getEvents: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.startDate) params.append("start_date", filters.startDate);
    if (filters.endDate) params.append("end_date", filters.endDate);
    if (filters.eventType) params.append("event_type", filters.eventType);
    if (filters.status) params.append("status", filters.status);
    if (filters.employeeId) params.append("employee_id", filters.employeeId);
    if (filters.candidateId) params.append("candidate_id", filters.candidateId);
    
    console.log("[CalendarService] Fetching events with filters:", filters);
    console.log("[CalendarService] Query params:", params.toString());
    
    const response = await apiClient.get(`/calendar/events?${params.toString()}`);
    console.log("[CalendarService] Response status:", response.status);
    console.log("[CalendarService] Response data:", response.data);
    
    return response.data;
  },

  // Get all holidays (public endpoint - accessible to all roles)
  getHolidays: async (year = null, holidayType = null) => {
    try {
      const params = new URLSearchParams();
      if (year) params.append("year", year);
      if (holidayType) params.append("holiday_type", holidayType);
      
      console.log("[CalendarService] Fetching holidays with params:", {
        year,
        holidayType,
      });
      
      const response = await apiClient.get(
        `/holidays${params.toString() ? "?" + params.toString() : ""}`
      );
      
      console.log("[CalendarService] Holidays response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[CalendarService] Error fetching holidays:", error);
      throw error;
    }
  },

  // Get religious holidays by year
  getReligiousHolidaysByYear: async (year) => {
    const response = await apiClient.get(`/holidays/religious/${year}`);
    return response.data;
  },

  // Create religious holiday
  createReligiousHoliday: async (holidayData) => {
    const response = await apiClient.post("/holidays/religious", holidayData);
    return response.data;
  },

  // Update religious holiday
  updateReligiousHoliday: async (holidayId, holidayData) => {
    const response = await apiClient.put(`/holidays/religious/${holidayId}`, holidayData);
    return response.data;
  },

  // Toggle religious holiday status
  toggleReligiousHolidayStatus: async (holidayId, isActive) => {
    const response = await apiClient.patch(`/holidays/religious/${holidayId}/status?is_active=${isActive}`);
    return response.data;
  },

  // Delete holiday
  deleteHoliday: async (holidayId) => {
    const response = await apiClient.delete(`/holidays/${holidayId}`);
    return response.data;
  },

  // Custom Calendar Events
  createCustomEvent: async (eventData) => {
    const response = await apiClient.post("/calendar/custom-events", eventData);
    return response.data;
  },

  // Create event (alias for createCustomEvent)
  createEvent: async (eventData) => {
    const response = await apiClient.post("/calendar/custom-events", eventData);
    return response.data;
  },

  updateCustomEvent: async (eventId, eventData) => {
    const response = await apiClient.put(`/calendar/custom-events/${eventId}`, eventData);
    return response.data;
  },

  deleteCustomEvent: async (eventId) => {
    const response = await apiClient.delete(`/calendar/custom-events/${eventId}`);
    return response.data;
  },

  // Get single custom event by ID
  getEventById: async (eventId) => {
    const response = await apiClient.get(`/calendar/custom-events/${eventId}`);
    return response.data;
  },

  // Update event (alias for updateCustomEvent)
  updateEvent: async (eventId, eventData) => {
    const response = await apiClient.put(`/calendar/custom-events/${eventId}`, eventData);
    return response.data;
  },

  // Delete event (alias for deleteCustomEvent)
  deleteEvent: async (eventId) => {
    const response = await apiClient.delete(`/calendar/custom-events/${eventId}`);
    return response.data;
  },

  // Create holiday
  createHoliday: async (holidayData) => {
    const response = await apiClient.post("/holidays", holidayData);
    return response.data;
  },

  // Update holiday
  updateHoliday: async (holidayId, holidayData) => {
    try {
      console.log("[CalendarService] Updating holiday:", holidayId);
      console.log("[CalendarService] Payload:", holidayData);

      const response = await apiClient.put(
        `/holidays/${holidayId}`,
        holidayData
      );

      console.log("[CalendarService] Update response:", response.data);

      return response.data;
    } catch (error) {
      console.error(
        "[CalendarService] Update holiday error:",
        error.response?.data || error
      );

      throw error;
    }
  },
};

export default calendarService;
